module.exports = {
  returnNameForId: {
    36: 'Demitidos',
    38: 'Aposentados',
  },
  returnIdForName: {
    Demitidos: 36,
    Aposentados: 38,
  },
  returnIdForNameFormatted: {
    '36 - Demitidos': 36,
    '38 - Aposentados': 38,
  },
  returnNameFormattedForId: {
    36: '36 - Demitidos',
    38: '38 - Aposentados',
  },
};
